module.exports = __webpack_public_path__ + "img/icon-tv.7bb948be.svg";